import React, { Component } from "react";

import {
  CSidebar,
  CSidebarNav,
  CNav,
  CNavItem,
  CNavLink,
  CSidebarClose,
  CSidebarFooter,
  CTextarea,
  CButton,
  CListGroup,
  CListGroupItem,
  CDropdown,
  CDropdownToggle,
  CDropdownMenu,
  CDropdownItem,
  CTooltip,
  CSpinner,
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CModalFooter
} from "@coreui/react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import {
  setShowInterfaceNotes,
  setInterfaceNotes
} from "../../actions/noteActions";
import URL from "../../config/api";
import axios from "../../config/axios";
import Loading from "../Loading";

const propTypes = {
  children: PropTypes.node
};

const defaultProps = {};

class NotesSidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tab: 0,
      // info: "",
      insertText: "",
      editText: "",
      loading: false,
      modalDelete: false,
      selected: null,
      edit: false
    };
  }

  friendlyDate(date) {
    const dt = new Date(date);
    const hj = new Date();
    const months = [
      "Janeiro",
      "Fevereiro",
      "Março",
      "Abril",
      "Maio",
      "Junho",
      "Julho",
      "Agosto",
      "Setembro",
      "Outubro",
      "Novembro",
      "Dezembro"
    ];

    if (dt.getFullYear() !== hj.getFullYear()) {
      return `${dt.getDate()} de ${
        months[dt.getMonth()]
      } de ${dt.getFullYear()}`;
    }

    return `${dt.getDate()} de ${
      months[dt.getMonth()]
    }, às ${`00${dt.getHours()}`.slice(-2)}:${`00${dt.getMinutes()}`.slice(
      -2
    )}`;
  }

  changeTab(tab) {
    this.props.setInterfaceNotes(this.props.typeId, this.props.objId);

    this.setState({ tab });
  }

  insertNote() {
    if (this.state.insertText === "") return;

    this.setState({ loading: true });

    const obj = {
      description: this.state.insertText,
      type_id: this.props.typeId,
      obj_id: this.props.objId,
      user_id: this.props.user.user.id
    };

    axios
      .post(`${URL.api}communication/note/insert`, obj, {
        headers: { Authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          this.props.setInterfaceNotes(
            this.props.typeId,
            this.props.objId,
            false
          );
          this.setState({ insertText: "", loading: false });
        },
        error => {
          toastr.error("Erro!", error.response.statusText);
          this.setState({ loading: false });
        }
      );
  }

  deleteNote() {
    axios
      .post(
        `${URL.api}communication/note/delete/${this.state.selected}`,
        null,
        { headers: { Authorization: `Bearer ${this.props.user.token}` } }
      )
      .then(
        resp => {
          this.props.setInterfaceNotes(
            this.props.typeId,
            this.props.objId,
            false
          );

          this.setState({ modalDelete: false });
          this.props.setShowInterfaceNotes(true);
        },
        error => {
          toastr.error("Erro!", error.response.statusText);
          this.setState({ modalDelete: false });
          this.props.setShowInterfaceNotes(true);
        }
      );
  }

  updateNote() {
    if (this.state.editText === "") return;

    const obj = {
      description: this.state.editText
    };

    axios
      .post(`${URL.api}communication/note/update/${this.state.selected}`, obj, {
        headers: { Authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          this.props.setInterfaceNotes(
            this.props.typeId,
            this.props.objId,
            false
          );

          this.setState({ edit: false });
        },
        error => {
          toastr.error("Erro!", error.response.statusText);
          this.setState({ edit: false });
        }
      );
  }

  showChange(show) {
    this.props.setShowInterfaceNotes(show);

    if (show) {
      this.props.setInterfaceNotes(this.props.typeId, this.props.objId);
    }
  }

  render() {
    const loading = this.props.note.interfaceLoading;
    const notes = this.props.note.interfaceNotes;
    const show = this.props.note.showInterfaceNotes;

    return (
      <>
        <CModal
          show={this.state.modalDelete}
          onClose={() => this.setState({ modalDelete: false })}
          size="sm"
          closeOnBackdrop={false}
        >
          <CModalHeader closeButton>
            <CModalTitle>Apagar anotação</CModalTitle>
          </CModalHeader>
          <CModalBody>Deseja apagar a anotação selecionada?</CModalBody>
          <CModalFooter>
            <CButton color="danger" onClick={() => this.deleteNote()}>
              Apagar
            </CButton>{" "}
            <CButton
              color="secondary"
              onClick={() => {
                this.setState({ modalDelete: false });
                this.props.setShowInterfaceNotes(true);
              }}
            >
              Cancelar
            </CButton>
          </CModalFooter>
        </CModal>
        <CSidebar
          colorScheme="light"
          overlaid
          size="xl"
          show={show}
          className={`position-absolute c-sidebar-right${
            this.state.modalDelete ? " c-sidebar-show" : ""
          }`}
          onShowChange={show => {}}
        >
          <CSidebarClose
            onClick={() => this.props.setShowInterfaceNotes(false)}
          />
          <CNav variant="tabs" className="nav-underline nav-underline-primary">
            <CNavItem>
              <CNavLink
                active={this.state.tab === 0}
                onClick={() => this.changeTab(0)}
              >
                Do conteúdo
              </CNavLink>
            </CNavItem>
          </CNav>
          <CSidebarNav>
            {loading ? (
              <div className="p-3">
                <Loading />
              </div>
            ) : (
              <CListGroup>
                {notes.length > 0 ? (
                  notes.map((note, index) => (
                    <CListGroupItem
                      key={index}
                      style={{ borderLeft: 0, borderRight: 0 }}
                    >
                      <div className="d-flex">
                        {note.id === this.state.selected && this.state.edit ? (
                          <CTextarea
                            placeholder="Edite essa anotação"
                            rows={4}
                            value={this.state.editText}
                            onChange={e =>
                              this.setState({ editText: e.target.value })
                            }
                          />
                        ) : (
                          <div style={{ flex: 1 }}>{note.description}</div>
                        )}
                        <CDropdown>
                          <CDropdownToggle
                            color="white"
                            className="card-header-action remove-caret"
                          >
                            <i className="fa fa-ellipsis-v"></i>
                          </CDropdownToggle>
                          <CDropdownMenu placement="bottom-end">
                            {note.id === this.state.selected &&
                            this.state.edit ? (
                              <>
                                <CDropdownItem
                                  onClick={() => this.updateNote()}
                                >
                                  Salvar
                                </CDropdownItem>
                                <CDropdownItem
                                  onClick={() => this.setState({ edit: false })}
                                >
                                  Cancelar
                                </CDropdownItem>
                              </>
                            ) : (
                              <>
                                <CDropdownItem
                                  onClick={() =>
                                    this.setState({
                                      selected: note.id,
                                      editText: note.description,
                                      edit: true
                                    })
                                  }
                                >
                                  Editar
                                </CDropdownItem>
                                <CDropdownItem
                                  onClick={() =>
                                    this.setState({
                                      selected: note.id,
                                      modalDelete: true
                                    })
                                  }
                                >
                                  Apagar
                                </CDropdownItem>
                              </>
                            )}
                          </CDropdownMenu>
                        </CDropdown>
                      </div>
                      <small className="font-weight-bold">
                        {this.friendlyDate(note.created_at)}
                      </small>
                    </CListGroupItem>
                  ))
                ) : (
                  <div className="p-3 text-center text-muted">
                    Nenhuma anotação
                  </div>
                )}
              </CListGroup>
            )}
          </CSidebarNav>
          {this.state.tab === 0 && (
            <CSidebarFooter
              style={{ borderTop: "1px solid #d8dbe0" }}
              className="bg-white d-flex flex-column align-items-end"
            >
              <CTextarea
                placeholder="Escreva uma anotação"
                rows={4}
                value={this.state.insertText}
                onChange={e => this.setState({ insertText: e.target.value })}
              />
              <div className="d-flex justify-content-between w-100 align-items-center mt-2">
                <CTooltip content="A anotação será guardada nesse conteúdo">
                  <i
                    className="fa fa-info-circle text-muted"
                    style={{ fontSize: "1rem" }}
                  ></i>
                </CTooltip>

                <CButton
                  color="primary"
                  disabled={this.state.loading}
                  onClick={() => this.insertNote()}
                  className="d-flex justify-content-center align-items-center"
                >
                  <>
                    <span style={this.state.loading ? { opacity: 0 } : null}>
                      <i className="fa fa-floppy-o"></i>&nbsp; Salvar
                    </span>
                    {this.state.loading && (
                      <CSpinner
                        size="sm"
                        color="white"
                        style={{ position: "absolute" }}
                      />
                    )}
                  </>
                </CButton>
              </div>
            </CSidebarFooter>
          )}
        </CSidebar>
      </>
    );
  }
}

NotesSidebar.propTypes = propTypes;
NotesSidebar.defaultProps = defaultProps;

const mapStateToProps = state => ({ note: state.note, user: state.user });

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { setShowInterfaceNotes, setInterfaceNotes },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(NotesSidebar);
